// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"353":"dee4f961","967":"c1f62294"}[chunkId] + ".js";
};